import type { RouteObject } from "react-router-dom";
import ProtectedRoute from "../components/base/protected-route";

// Lazy load components
const HomePage = lazy(() => import("../pages/home/page"));
const DashboardPage = lazy(() => import("../pages/dashboard/page"));
const PatientsPage = lazy(() => import("../pages/patients/page"));
const AppointmentsPage = lazy(() => import("../pages/appointments/page"));
const MedicalRecordsPage = lazy(() => import("../pages/medical-records/page"));
const FinancialPage = lazy(() => import("../pages/financial/page"));
const FinancialV2Page = lazy(() => import("../pages/financial-v2/page"));
const StockPage = lazy(() => import("../pages/stock/page"));
const WhatsAppPage = lazy(() => import("../pages/whatsapp/page"));
const AutomationPage = lazy(() => import("../pages/automation/page"));
const SettingsPage = lazy(() => import("../pages/settings/page"));
const LoginPage = lazy(() => import("../pages/auth/login-page"));
const NotFoundPage = lazy(() => import("../pages/not-found"));
const PatientsModulePage = lazy(() => import("../pages/patients-module/page"));
const ReferralsPage = lazy(() => import("../pages/referrals/page"));
const PatientReferralsPage = lazy(() => import("../pages/referrals/patient/[id]/page"));
const NotificationsPage = lazy(() => import("../pages/notifications/page"));
const EmployeesPage = lazy(() => import("../pages/employees/page"));
const UnauthorizedPage = lazy(() => import("../pages/unauthorized"));
const ForgotPasswordPage = lazy(() => import("../pages/forgot-password/page"));
const ResetPasswordPage = lazy(() => import("../pages/reset-password/page"));
const TermsPage = lazy(() => import("../pages/terms-page"));
const PrivacyPage = lazy(() => import("../pages/privacy-page"));

const routes: RouteObject[] = [
	{
		path: "/",
		element: <HomePage />,
	},
	{
		path: "/login",
		element: <LoginPage />,
	},
	{
		path: "/forgot-password",
		element: <ForgotPasswordPage />,
	},
	{
		path: "/reset-password",
		element: <ResetPasswordPage />,
	},
	{
		path: "/dashboard",
		element: <DashboardPage />,
	},
	{
		path: "/patients",
		element: <PatientsPage />,
	},
	{
		path: "/pacientes",
		element: <PatientsPage />,
	},
	{
		path: "/appointments",
		element: <AppointmentsPage />,
	},
	{
		path: "/agendamentos",
		element: <AppointmentsPage />,
	},
	{
		path: "/medical-records",
		element: (
			<ProtectedRoute allowedRoles={["doctor"]}>
				<MedicalRecordsPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/prontuarios",
		element: (
			<ProtectedRoute allowedRoles={["doctor"]}>
				<MedicalRecordsPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/financial",
		element: <FinancialPage />,
	},
	{
		path: "/financeiro",
		element: <FinancialPage />,
	},
	{
		path: "/financial-v2",
		element: <FinancialV2Page />,
	},
	{
		path: "/financeiro-novo",
		element: <FinancialV2Page />,
	},
	{
		path: "/stock",
		element: <StockPage />,
	},
	{
		path: "/estoque",
		element: <StockPage />,
	},
	{
		path: "/whatsapp",
		element: <WhatsAppPage />,
	},
	{
		path: "/automation",
		element: (
			<ProtectedRoute allowedRoles={["doctor"]}>
				<AutomationPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/automacao",
		element: (
			<ProtectedRoute allowedRoles={["doctor"]}>
				<AutomationPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/settings",
		element: <SettingsPage />,
	},
	{
		path: "/configuracoes",
		element: <SettingsPage />,
	},
	{
		path: "/notifications",
		element: <NotificationsPage />,
	},
	{
		path: "/notificacoes",
		element: <NotificationsPage />,
	},
	{
		path: "/employees",
		element: (
			<ProtectedRoute allowedRoles={["doctor", "admin"]}>
				<EmployeesPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/funcionarios",
		element: (
			<ProtectedRoute allowedRoles={["doctor", "admin"]}>
				<EmployeesPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/patients-module",
		element: <PatientsModulePage />,
	},
	{
		path: "/referrals",
		element: <ReferralsPage />,
	},
	{
		path: "/referrals/patient/:id",
		element: <PatientReferralsPage />,
	},
	{
		path: "/unauthorized",
		element: <UnauthorizedPage />,
	},
	{
		path: "/terms",
		element: <TermsPage />,
	},
	{
		path: "/privacy",
		element: <PrivacyPage />,
	},
	{
		path: "*",
		element: <NotFoundPage />,
	},
];

export default routes;
